export const NO_TAG_TEXT = 'No tag';

export const DOCUMENT_TAG_SHORT_CODES: Readonly<Partial<Record<string, string>>> = {
    'task-card': 'tc',
    'shop-visit': 'sv',
    'status-report': 'sr',
    'job-card': 'jc',
    'comp-shop': 'cs',
    repair: 'rep',
    'asset-mm': 'assmm',
    'tech-log': 'tl',
    'flight-log': 'fl',
    'sl-tag': 'sl',
    'check-sheet': 'chk',
};

export const DOCUMENTS_STATUS_TEXTS = {
    pending: 'Loading documents…',
    error: 'The documents could not be loaded.',
    empty: 'No documents in this cluster.',
};
